import { AxiosInstance } from 'axios'
import { MediaObject } from '@/shared/api/strapi/requests/types'
import { BlocksContent } from '@strapi/blocks-react-renderer'

export interface GetPromotionsArgs {
  locale: string
  serviceCategoryId?: string
}

export interface PromotionDto {
  id: number
  attributes: {
    start: string
    finish: string
    name: string
    image: MediaObject
    text: BlocksContent
    short_text: string
  }
}

export const getPromotions = async (client: AxiosInstance, { locale, serviceCategoryId }: GetPromotionsArgs) => {
  const currentDate = new Date().toISOString()
  const path = `/promotions`
  const params = {
    locale: locale,
    sort: { createdAt: 'asc' },
    filters: {
      ...(serviceCategoryId
        ? {
            services: {
              categories: {
                id: {
                  $eq: serviceCategoryId,
                },
              },
            },
          }
        : {}),
      start: { $lte: currentDate },
      finish: { $gte: currentDate },
    },
    populate: '*',
  }
  return (await client.get<{ data: PromotionDto[] }>(path, { params })).data.data
}
